module.exports = __webpack_public_path__ + "img/shopping-cart.6ac76dff.svg";